// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
    text-align: center;
}

.App-logo {
    height: 40vmin;
    pointer-events: none;
}

.btn-splendi-blue {
    color: white;
    border-radius: 4px;
    background: #5151f9;
}

.btn-splendi-blue:hover {
    background: #5151f9;
    color: #fff;
    box-shadow: 0 0 10px #1b1b1b;
}

.btn-black {
    background-color: black;
    color: white;
}

.btn-black:hover {
    background-color: black;
    color: white;
    box-shadow: 0 0 10px #1b1b1b;
}

.btn-custom-1 {
    background-color: white;
    color: #007bff;
    border: 2px solid #007bff;
    transition: border-color 0.3s, box-shadow 0.3s; /* Smooth transition */
}

.btn-custom-1:hover {
    border-color: #64abf7;
    box-shadow: 0 0 10px #64abf7;
}

.btn-custom-2 {
    border-color: rgb(230, 8, 8);
    box-shadow: 0 0 10px rgb(230, 8, 8);
}

.btn-custom-2 :hover {
    border-color: rgb(230, 8, 8);
    box-shadow: 0 0 10px rgb(230, 8, 8);
}

/* Custom CSS for the circled cross icon */
.error-icon {
    display: inline-block;
    width: 1.7vw;
    height: 2.7vh;
    border: 2px solid red;
    border-radius: 50%;
    background-color: white;
    color: red;
    font-weight: bold;
    line-height: 2vh;
    text-align: center;
}

.cross-icon {
    position: relative;
    top: 1px;
    font-weight: bold;
}

.password-input-container {
    position: relative;
}

.btn {
    height: 55px !important;
    align-content: center;
}

.password-toggle-icon {
    position: absolute;
    top: 32px;
    right: 14px;
    transform: translateY(-50%);
    cursor: pointer;
}

.card.no-border {
    border: none;
    box-shadow: 10px #f5f2f2;
}

.card-header.no-border {
    border-bottom: none;
    background-color: white;
}

.card-header.text-center {
    text-align: center;
    color: #007bff !important;
    padding: 0 !important;
    margin-bottom: 25px;
    font-size: 36px;
}

.form-control {
    border-radius: 0.175rem !important;
    height: 65px;
    margin: 0 auto;
}

.form-label {
    /* display: inline-block;
  width: 70%; 
  height: 6vh;
  margin: 0 auto;  */
}

.form-group {
    margin-bottom: 1rem;
}

.btn-group {
    display: flex;
    justify-content: center;
}

.btn-group .btn {
    width: 70%; /* Match the width of form controls */
    margin: 0 auto; /* Center the buttons */
}

.hr-line {
    width: 100%;
    height: 2px;
    background-color: #ccc;
}

.speech-bubble {
    position: relative;
    background: #0a0d29;
    border-radius: 0.4em;
    color: #fff;
}

.speech-bubble:after {
    content: '';
    position: absolute;
    right: 0;
    top: 50%;
    width: 0;
    height: 0;
    border: 20px solid transparent;
    border-left-color: #0a0d29;
    border-right: 0;
    border-bottom: 0;
    margin-top: -10px;
    margin-right: -20px;
}

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

/* Firefox */
input[type='number'] {
    -moz-appearance: textfield;
}

.ml-6 {
    margin-left: 6vw !important;
    margin-right: 6vw !important;
}

p {
    margin-top: 0;
    margin-bottom: 0rem;
}

.edit-profile-loader {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 400px;
}

/* Carousel Styles */
.splide__pagination {
    position: relative !important;
    margin-top: 10px !important;
}

/* Global MDB Restyle */
.form-control.is-invalid {
    background-image: none !important;
}

#edit-profile-nav {
    display: flex;
}

#edit-profile-nav-mobile {
    display: none;
}

@media (max-width: 768px) {
    /* .form-control {
        width: 100%; 
    } */

    /* .ml-6 {
        margin-left: 0 !important;
        margin-right: 0 !important;
    } */

    /* .card-header.text-center {
        font-size: 30px;
    } */

    .splide {
        width: 70vw;
    }
}

@media (max-width: 992px) {
    .form-control {
        width: 100%; /* Adjust width for smaller screens */
    }

    .ml-6 {
        margin-left: 0 !important;
        margin-right: 0 !important;
    }

    .card-header.text-center {
        font-size: 30px;
    }

    #edit-profile-nav {
        display: none;
    }

    #edit-profile-nav-mobile {
        display: flex;
    }

    .table-container {
        overflow: scroll;
    }
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,oBAAoB;AACxB;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,4BAA4B;AAChC;;AAEA;IACI,uBAAuB;IACvB,YAAY;AAChB;;AAEA;IACI,uBAAuB;IACvB,YAAY;IACZ,4BAA4B;AAChC;;AAEA;IACI,uBAAuB;IACvB,cAAc;IACd,yBAAyB;IACzB,8CAA8C,EAAE,sBAAsB;AAC1E;;AAEA;IACI,qBAAqB;IACrB,4BAA4B;AAChC;;AAEA;IACI,4BAA4B;IAC5B,mCAAmC;AACvC;;AAEA;IACI,4BAA4B;IAC5B,mCAAmC;AACvC;;AAEA,0CAA0C;AAC1C;IACI,qBAAqB;IACrB,YAAY;IACZ,aAAa;IACb,qBAAqB;IACrB,kBAAkB;IAClB,uBAAuB;IACvB,UAAU;IACV,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,uBAAuB;IACvB,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,2BAA2B;IAC3B,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,wBAAwB;AAC5B;;AAEA;IACI,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,qBAAqB;IACrB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,kCAAkC;IAClC,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI;;;oBAGgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,UAAU,EAAE,qCAAqC;IACjD,cAAc,EAAE,uBAAuB;AAC3C;;AAEA;IACI,WAAW;IACX,WAAW;IACX,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,oBAAoB;IACpB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,QAAQ;IACR,QAAQ;IACR,SAAS;IACT,8BAA8B;IAC9B,0BAA0B;IAC1B,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA,gCAAgC;AAChC;;IAEI,wBAAwB;IACxB,SAAS;AACb;;AAEA,YAAY;AACZ;IACI,0BAA0B;AAC9B;;AAEA;IACI,2BAA2B;IAC3B,4BAA4B;AAChC;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA,oBAAoB;AACpB;IACI,6BAA6B;IAC7B,2BAA2B;AAC/B;;AAEA,uBAAuB;AACvB;IACI,iCAAiC;AACrC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI;;OAEG;;IAEH;;;OAGG;;IAEH;;OAEG;;IAEH;QACI,WAAW;IACf;AACJ;;AAEA;IACI;QACI,WAAW,EAAE,qCAAqC;IACtD;;IAEA;QACI,yBAAyB;QACzB,0BAA0B;IAC9B;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,gBAAgB;IACpB;AACJ","sourcesContent":[".App {\n    text-align: center;\n}\n\n.App-logo {\n    height: 40vmin;\n    pointer-events: none;\n}\n\n.btn-splendi-blue {\n    color: white;\n    border-radius: 4px;\n    background: #5151f9;\n}\n\n.btn-splendi-blue:hover {\n    background: #5151f9;\n    color: #fff;\n    box-shadow: 0 0 10px #1b1b1b;\n}\n\n.btn-black {\n    background-color: black;\n    color: white;\n}\n\n.btn-black:hover {\n    background-color: black;\n    color: white;\n    box-shadow: 0 0 10px #1b1b1b;\n}\n\n.btn-custom-1 {\n    background-color: white;\n    color: #007bff;\n    border: 2px solid #007bff;\n    transition: border-color 0.3s, box-shadow 0.3s; /* Smooth transition */\n}\n\n.btn-custom-1:hover {\n    border-color: #64abf7;\n    box-shadow: 0 0 10px #64abf7;\n}\n\n.btn-custom-2 {\n    border-color: rgb(230, 8, 8);\n    box-shadow: 0 0 10px rgb(230, 8, 8);\n}\n\n.btn-custom-2 :hover {\n    border-color: rgb(230, 8, 8);\n    box-shadow: 0 0 10px rgb(230, 8, 8);\n}\n\n/* Custom CSS for the circled cross icon */\n.error-icon {\n    display: inline-block;\n    width: 1.7vw;\n    height: 2.7vh;\n    border: 2px solid red;\n    border-radius: 50%;\n    background-color: white;\n    color: red;\n    font-weight: bold;\n    line-height: 2vh;\n    text-align: center;\n}\n\n.cross-icon {\n    position: relative;\n    top: 1px;\n    font-weight: bold;\n}\n\n.password-input-container {\n    position: relative;\n}\n\n.btn {\n    height: 55px !important;\n    align-content: center;\n}\n\n.password-toggle-icon {\n    position: absolute;\n    top: 32px;\n    right: 14px;\n    transform: translateY(-50%);\n    cursor: pointer;\n}\n\n.card.no-border {\n    border: none;\n    box-shadow: 10px #f5f2f2;\n}\n\n.card-header.no-border {\n    border-bottom: none;\n    background-color: white;\n}\n\n.card-header.text-center {\n    text-align: center;\n    color: #007bff !important;\n    padding: 0 !important;\n    margin-bottom: 25px;\n    font-size: 36px;\n}\n\n.form-control {\n    border-radius: 0.175rem !important;\n    height: 65px;\n    margin: 0 auto;\n}\n\n.form-label {\n    /* display: inline-block;\n  width: 70%; \n  height: 6vh;\n  margin: 0 auto;  */\n}\n\n.form-group {\n    margin-bottom: 1rem;\n}\n\n.btn-group {\n    display: flex;\n    justify-content: center;\n}\n\n.btn-group .btn {\n    width: 70%; /* Match the width of form controls */\n    margin: 0 auto; /* Center the buttons */\n}\n\n.hr-line {\n    width: 100%;\n    height: 2px;\n    background-color: #ccc;\n}\n\n.speech-bubble {\n    position: relative;\n    background: #0a0d29;\n    border-radius: 0.4em;\n    color: #fff;\n}\n\n.speech-bubble:after {\n    content: '';\n    position: absolute;\n    right: 0;\n    top: 50%;\n    width: 0;\n    height: 0;\n    border: 20px solid transparent;\n    border-left-color: #0a0d29;\n    border-right: 0;\n    border-bottom: 0;\n    margin-top: -10px;\n    margin-right: -20px;\n}\n\n/* Chrome, Safari, Edge, Opera */\ninput::-webkit-outer-spin-button,\ninput::-webkit-inner-spin-button {\n    -webkit-appearance: none;\n    margin: 0;\n}\n\n/* Firefox */\ninput[type='number'] {\n    -moz-appearance: textfield;\n}\n\n.ml-6 {\n    margin-left: 6vw !important;\n    margin-right: 6vw !important;\n}\n\np {\n    margin-top: 0;\n    margin-bottom: 0rem;\n}\n\n.edit-profile-loader {\n    width: 100%;\n    height: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    min-height: 400px;\n}\n\n/* Carousel Styles */\n.splide__pagination {\n    position: relative !important;\n    margin-top: 10px !important;\n}\n\n/* Global MDB Restyle */\n.form-control.is-invalid {\n    background-image: none !important;\n}\n\n#edit-profile-nav {\n    display: flex;\n}\n\n#edit-profile-nav-mobile {\n    display: none;\n}\n\n@media (max-width: 768px) {\n    /* .form-control {\n        width: 100%; \n    } */\n\n    /* .ml-6 {\n        margin-left: 0 !important;\n        margin-right: 0 !important;\n    } */\n\n    /* .card-header.text-center {\n        font-size: 30px;\n    } */\n\n    .splide {\n        width: 70vw;\n    }\n}\n\n@media (max-width: 992px) {\n    .form-control {\n        width: 100%; /* Adjust width for smaller screens */\n    }\n\n    .ml-6 {\n        margin-left: 0 !important;\n        margin-right: 0 !important;\n    }\n\n    .card-header.text-center {\n        font-size: 30px;\n    }\n\n    #edit-profile-nav {\n        display: none;\n    }\n\n    #edit-profile-nav-mobile {\n        display: flex;\n    }\n\n    .table-container {\n        overflow: scroll;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
